import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import axios from "axios";
import { motion } from 'framer-motion';
import { Mail, Lock } from 'lucide-react';
import { useNotification } from "../components/NotificationContext";
import { useAuth } from "../auth/AuthContext";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();
  const showNotification = useNotification();

  const handleLogin = async (e) => {
    e.preventDefault(); // Sayfa yenilenmesini engelle
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/loginPanel`, {
        email,
        password,
      });

      localStorage.setItem("token", response.data.token);
      const { role,id } = response.data;
      localStorage.setItem("role", role);
      localStorage.setItem("id", id);
      login(role);
      showNotification("Giriş başarılı! Hoş geldiniz.", "success");
      navigate("/");
    } catch (err) {
      showNotification("Giriş başarısız! Lütfen bilgilerinizi kontrol edin.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-secondary-light py-12"
    >
      <div className="container-custom max-w-md">
        <div className="bg-white rounded-lg shadow-medium p-8">
          <h1 className="text-2xl font-bold text-gray-dark mb-6">Giriş Yap</h1>

          {error && (
            <div className="bg-red-50 text-red-600 p-3 rounded-md mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-dark mb-1">
                E-posta
              </label>
              <div className="relative">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
                <Mail className="absolute left-3 top-2.5 text-gray" size={18} />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="password" className="block text-gray-dark mb-1">
                Şifre
              </label>
              <div className="relative">
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
                <Lock className="absolute left-3 top-2.5 text-gray" size={18} />
              </div>
            </div>

            <button
              type="submit"
              className="w-full btn-primary mb-4"
              disabled={loading}
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>

          <p className="text-center text-gray">
            Hesabınız yok mu?{" "}
            <Link to="/register" className="text-primary hover:text-primary-dark">
              Hemen Kaydolun
            </Link>
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default LoginPage;
